// 由顾客访问统计表（2024全过程咨询 xlsx、2025项目管理 xlsx、2023/2025监理 docx、2025上半年 pdf）汇总生成
export default [
  {
    "contract": "【汇总】2025上半年监理顾客访问（排列图）",
    "subject": "【2025监理·上半年分布】据《AA2025上半年顾客访问记录分布情况表.pdf》，共31项列入评价；表内均为满意1次/项。首项「镇海技工学校建设工程」至末项「宁波枢纽南门户汇诚路道路工程」等（PDF 文本提取，序号与合计以原表为准）。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "江东戎家3#地块（暂停）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年无访问或未开工；全年访问合计0次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "未访问",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "洞桥上水碶（竣工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "集士港设计产业园（竣工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行奉化项目",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "奉化农商银行大楼新建工程",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "集士港万众村",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "石碶街道冯家村",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "北仑文化中心",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "镇海技工学校",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "七塔寺两馆三园项目",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "七塔寺素斋馆项目",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "大嵩租赁住房（竣工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行总部二期",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁穿路幼儿园",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "艾思科厂房建设装修工程",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "首南中学扩建工程（竣工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行科技中心",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "汽车配套新建厂房项目",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "镇海萌恒项目",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波植物园展览温室",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "南苑酒店改造",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "洞桥镇区安置房DQ-06-K1（未开工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年无访问或未开工；全年访问合计0次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "未访问",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "洞桥镇区安置房DQ-08-C1（未开工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年无访问或未开工；全年访问合计0次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "未访问",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "后庙九年一贯制学校（未开工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年无访问或未开工；全年访问合计0次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "未访问",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行数据中心三期",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "甬舟铁路鄞州段管线迁改工程（未开工）",
    "subject": "【2024全过程咨询项目管理·2024】顾客访问：上半年无访问或未开工；下半年无访问或未开工；全年访问合计0次（表内全年合计列）。来源：2024全过程咨询项目管理统计表。",
    "status": "未访问",
    "next_follow": "—",
    "updated_at": "2024-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "石碶街道冯家村",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "北仑文化中心",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "镇海技工学校",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行总部二期",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行科技中心",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "镇海萌恒项目",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波植物园展览温室",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "洞桥镇区安置房DQ-08-C1",
    "subject": "【2025项目管理·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "后庙九年一贯制学校",
    "subject": "【2025项目管理·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "宁波银行数据中心三期",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "余姚农商行",
    "subject": "【2025项目管理·2025】顾客访问：上半年满意1次；下半年满意1次、较满意1次；全年访问合计2次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "较满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "鄞州二院改造",
    "subject": "【2025项目管理·2025】顾客访问：上半年无访问或未开工；下半年满意1次、较满意1次；全年访问合计1次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "较满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "仇毕坊零碳示范基地",
    "subject": "【2025项目管理·2025】顾客访问：上半年无访问或未开工；下半年满意1次、较满意1次；全年访问合计1次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "较满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "工商学院",
    "subject": "【2025项目管理·2025】顾客访问：上半年无访问或未开工；下半年满意1次、较满意1次；全年访问合计1次（表内全年合计列）。来源：2025项目管理统计表。",
    "status": "较满意",
    "next_follow": "—",
    "updated_at": "2025-12-31",
    "owner": "张建儿"
  },
  {
    "contract": "跨境贸易数智港",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "富阳八小",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "西安未来之瞳",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "镇海科技文创（一期）",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行金融产业园",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁大西研究生公寓",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "映荷佳苑2期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "集士港元禾村新村建设",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "中西医结合医院",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "市镇海技工学校",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "石碶冯家村新村建设",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年较满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "较满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "丽园路安置房",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "琎琳站生活配套中心",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "北仑区文化中心",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "七塔禅寺周边两馆等",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "文创港二期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "文创港一期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "文创港3期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行余姚支行",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "洞桥镇上水碶新村",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁海十里红妆",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "金沙书院",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "万众村安置房",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "梅山国际冷链",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "蛟川迎周配套中心",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "甬江产业园",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "绍兴公共镜湖总部",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波曼哈顿大厦",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "江北智能产业园",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "海曙设计产业园",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "大嵩人才房",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行奉化支行",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "奉化农商银行大楼",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "园中村2期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "园中村1期",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "镇海龙源社区",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "江口蒋葭浦安置房",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波南部交通枢纽及配套工程一期",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "富阳姚家畈安置房",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "富阳春北安置小区",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "世纪大道快速路2标",
    "subject": "【2023监理项目·2023】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "富阳东洲人才公寓",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波艾思科厂房项目",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁穿路A1-4幼儿园",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "金源路小学",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "慈溪明月湖",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "鄞州大道快速路",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "邵家渡大桥3标",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "轨道交通7008标",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "集士港机场安置道路",
    "subject": "【2023监理项目·2023】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2023监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2023-12-31",
    "owner": "胡晓灯"
  },
  {
    "contract": "镇海技工学校建设工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "西安未来之瞳",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "镇海科技文创（一期）",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "石碶冯家村新村建设一期",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "丽园路安置房",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "慈溪新城河 G#-1 安置房",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "集士港镇元禾村新村建设",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "方桥学校",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行总部二期",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "北仑区文化中心",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "高新区未来产业园",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波曼哈顿大厦",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁海十里红妆",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行数据中心三期",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "龙山保障性租赁房",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "仇毕坊零碳示范基地",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "高新区人才公寓南区",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "年产5亿套高精密轴承",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "海曙区老旧厂区（新能源中心）改造工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "琎琳站生活配套服务中心",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "工商技术学院海曙校区工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "鄞州网球中心改造",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年无访问或未开工；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "大碶徐洋高中新建工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "文创港三期",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波植物园展览温室项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "余姚商业用房建设项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "甬江软件产业园",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "年产80万套电子器件项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波外事学校二期改扩建工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "萌恒段塘项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波银行鄞州科技中心",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波高新区太平鸟全球时尚研发中心项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "邵家渡大桥及接线工程土建监理Ⅲ标段",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波市轨道交通TJJL7008标（含宁慈线）",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "庆丰桥人非系统改造工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "秋实路工程监理II标段",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "汇诚路道路工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "世纪大道快速路南延启动段",
    "subject": "【2025监理项目·2025】顾客访问：上半年满意1次；下半年满意1次；全年访问合计2次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "宁波市海曙区三市地块配套道路工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "洞桥百梁桥村新村建设",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "市管隧道、地道、天桥及道路养护项目",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "后庙工业区九年一贯制学校",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "梅山冷链一期后续附属工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "年产500台设备制造",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "镇海综合体育中心建设工程",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  },
  {
    "contract": "鄞州二院改造",
    "subject": "【2025监理项目·2025】顾客访问：上半年无访问或未开工；下半年满意1次；全年访问合计1次（表内全年合计列）。来源：2025监理项目统计表。",
    "status": "满意",
    "next_follow": "—",
    "updated_at": "2026-01-20",
    "owner": "胡晓灯"
  }
];
